// extracted by mini-css-extract-plugin
export var cardContainer = "L_cm";
export var ourValues = "L_cl";
export var title = "L_bd";